import { GA4_ID } from './config.ts';

// gtag buffers calls onto `dataLayer` until the async script drains the queue,
// so calls issued before the loader finishes are not lost.
declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}

let injected = false;

/**
 * Idempotently inject the GA4 loader and initialise gtag. Configured with
 * `send_page_view: false` so page_view is sent manually per route (including the
 * first load) — this counts SPA navigations and avoids double-counting load #1.
 */
export function loadGtag(): void {
  if (injected || document.getElementById('ga4-loader')) return;
  injected = true;

  const script = document.createElement('script');
  script.id = 'ga4-loader';
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag(...args: unknown[]) {
    window.dataLayer.push(args);
  };
  window.gtag('js', new Date());
  window.gtag('config', GA4_ID, { send_page_view: false });
}

/** Send one GA4 page_view for the given SPA path. */
export function trackPageView(path: string): void {
  if (typeof window.gtag !== 'function') return;
  window.gtag('event', 'page_view', {
    page_path: path,
    page_location: window.location.href,
  });
}
